import * as Sentry from "@sentry/react";

export const logSentryError = (err: unknown, page: string, tag: string) => {
  Sentry.withScope((scope) => {
    scope.setTag(page, tag);
    Sentry.captureException(err);
  });
};

export const logSentryMessage = (
  message: string,
  page: string,
  tag: string,
) => {
  Sentry.withScope((scope) => {
    scope.setTag(page, tag);
    Sentry.captureMessage(message);
  });
};
